module.exports = __webpack_public_path__ + "static/media/background.bb73931b.jpg";